<script setup lang="js">
import Context from "@/components/Context.vue";
import ContextColors from "@/components/ContextColors.vue";
import {ref} from "vue";
  const  ywjz = ref('https://cos5.51tgqj.com/techming/img/ywjz@2x.png')
  const  zfcjjfa = ref('https://cos5.51tgqj.com/techming/img/zfcjjfa@2x.png')
  const  qycjjfa = ref('https://cos5.51tgqj.com/techming/img/qycjjfa@2x.png')
  const  jsfn = ref('https://cos5.51tgqj.com/techming/img/jsfn@2x.png')
  const  jykjql = ref('https://cos5.51tgqj.com/techming/img/jykjql@2x.png')
  const  yhcjjfa = ref('https://cos5.51tgqj.com/techming/img/yhcjjfa@2x.png')
  const  ywjz6 = ref('https://cos5.51tgqj.com/techming/img/ywjz6@2x.png')
  const  jyIPgc = ref('https://cos5.51tgqj.com/techming/img/jyIPgc@2x.png')
  const  szjyxt = ref('https://cos5.51tgqj.com/techming/img/szjyxt@2x.png')
  const  jyhdst = ref('https://cos5.51tgqj.com/techming/img/jyhdst@2x.png')
  const  jyjjbh = ref('https://cos5.51tgqj.com/techming/img/jyjjbh@2x.png')

  const tableData = [
    {
      date: '典型项目',
      name: '',
      address: '',
    },
    {
      date: '零工驿站',
      name: '即时岗位墙+技能超市',
      address: '川渝高祖新区数智零工驿站',
    },
    {
      date: '青创中心',
      name: '项目路演厅+资源对接舱',
      address: '邻水县青年就业创业创中心',
    },
    {
      date: '社区微创园',
      name: '共享工位+社区生活',
      address: '广安市白塔社区微创园',
    },
    {
      date: '实训基地',
      name: '实训室+展厅+共享孵化',
      address: '邻水县公共实训基地',
    },
    {
      date: '产教基地',
      name: '实训车间+企业工作室',
      address: '川渝高竹新区产业学院',
    },
  ]


  const tableData1 = [
    {
      date: '应用成效',
      name: '',
      address: '',
    },
    {
      date: '广场舞噪音监测',
      name: '声纹识别+自动预警',
      address: '启动3个月投诉降为0',
    },
    {
      date: '政务会务系统',
      name: '无纸化协同+智能排期',
      address: '会务效率提升200%',
    },
    {
      date: '川渝一体化办案',
      name: '跨域数据通办+电子存证',
      address: '群众跑动减少90%',
    },
    {
      date: '文化惠民系统',
      name: '艺团申报+市民点单',
      address: '文化下乡，效率提升300%',
    },
  ]


</script>

<template>
<div>
  <context-colors color="bg-[#21FF21]" class="flex justify-center text-center">
      <el-image :src="ywjz" class="w-2/3"/>
  </context-colors>
  <context>
    <div class="text-center">
      <el-image :src="zfcjjfa" class="lg:w-1/5 md:w-1/2"/>
    </div>
    <div class="mt-5 text-white">
      <div class="text-3xl md:text-3xl lg:text-[1.8rem]">核心痛点</div>
      <div class="text-[1.3rem] md:text-[1.3rem] lg:text-[1.5rem] mt-2">▸区域就业数据分散难整合</div>
      <div class="text-[1.3rem] md:text-[1.3rem] lg:text-[1.5rem] mt-1">▸传统就业服务触达率低</div>
      <div class="text-[1.3rem] md:text-[1.3rem] lg:text-[1.5rem] mt-1">▸创业孵化与产业需求脱节</div>
      <div class="text-[1.3rem] md:text-[1.3rem] lg:text-[1.5rem] mt-1">▸重点群体就业帮扶效率低</div>
    </div>
    <div class="mt-5 text-white ">
      <div class="text-3xl md:text-3xl lg:text-[1.8rem]">解决方案</div>
      <div class="text-[1.3rem] md:text-[1.3rem] lg:text-[1.6rem] mt-2">1.就业数智中枢系统</div>
      <div class="text-[1.3rem] md:text-[1.3rem] lg:text-[1.5rem] mt-1">核心功能：</div>
      <div class="text-[1.3rem] md:text-[1.3rem] lg:text-[1.5rem] mt-1">▸多源数据融合（社保/教育/工商数据互通）</div>
      <div class="text-[1.3rem] md:text-[1.3rem] lg:text-[1.5rem] mt-1">▸就业热力图预警（失业率/岗位缺口实时监测）</div>
      <div class="text-[1.3rem] md:text-[1.3rem] lg:text-[1.5rem] mt-1">▸政策模拟沙盘（补贴政策效果预测）</div>
      <div class="text-[1.3rem] md:text-[1.3rem] lg:text-[1.6rem] mt-1">2.产教融合示范基地服务模块：</div>
      <div class="text-[1.3rem] md:text-[1.3rem] lg:text-[1.5rem] mt-1">服务模块：</div>
      <div class="text-[1.3rem] md:text-[1.3rem] lg:text-[1.5rem] mt-1">▸产业人才需求图谱</div>
      <div class="text-[1.3rem] md:text-[1.3rem] lg:text-[1.5rem] mt-1">▸“岗位-培训-认证”直通车</div>
      <div class="text-[1.3rem] md:text-[1.3rem] lg:text-[1.5rem] mt-1">▸校企资源智能匹配系统</div>
    </div>
  </context>
  <context-colors color="bg-[#ffffff]">
    <div class="text-center">
      <el-image :src="qycjjfa" class="lg:w-1/5 md:w-1/3"/>
    </div>
    <div class="mt-5 text-[#414244]">
      <div class="text-3xl md:text-3xl lg:text-[1.8rem]">核心痛点</div>
      <div class="text-[1.3rem] md:text-[1.3rem] lg:text-[1.5rem] mt-2">▸季节性用工波动难应对</div>
      <div class="text-[1.3rem] md:text-[1.3rem] lg:text-[1.5rem] mt-1">▸技能型人才招聘成本高</div>
      <div class="text-[1.3rem] md:text-[1.3rem] lg:text-[1.5rem] mt-1">▸员工持续培养体系缺失</div>
      <div class="text-[1.3rem] md:text-[1.3rem] lg:text-[1.5rem] mt-1">▸灵活用工管理风险大</div>
    </div>
    <div class="mt-5 text-[#414244]">
      <div class="text-3xl md:text-3xl lg:text-[1.8rem]">解决方案</div>
      <div class="text-[1.3rem] md:text-[1.3rem] lg:text-[1.5rem] mt-2">1.智慧零工市场系统</div>
      <div class="text-[1.3rem] md:text-[1.3rem] lg:text-[1.5rem] mt-1">功能亮点：</div>
      <div class="text-[1.3rem] md:text-[1.3rem] lg:text-[1.5rem] mt-1">▸灵活用工信用评价体系</div>
      <div class="text-[1.3rem] md:text-[1.3rem] lg:text-[1.5rem] mt-1">▸工作任务智能拆解派单</div>
      <div class="text-[1.3rem] md:text-[1.3rem] lg:text-[1.5rem] mt-1">▸合规化电子合约管理2</div>
      <div class="text-[1.3rem] md:text-[1.3rem] lg:text-[1.5rem] mt-1">2.技能人才定制工场：</div>
      <div class="text-[1.3rem] md:text-[1.3rem] lg:text-[1.5rem] mt-1">服务流程：</div>
      <div class="text-[1.3rem] md:text-[1.3rem] lg:text-[1.5rem] mt-1">①岗位能力建模→②培训课程开发→③虚拟仿真实训→④上岗动态跟踪</div>
    </div>
  </context-colors>
  <context>
    <div class="text-center">
      <el-image :src="yhcjjfa" class="lg:w-1/5 md:w-1/3"/>
    </div>
    <div class="mt-5 text-white">
      <div class="text-3xl md:text-3xl lg:text-[1.8rem]">核心痛点</div>
      <div class="text-[1.3rem] md:text-[1.3rem] lg:text-[1.5rem] mt-2">▸求职者：技能与岗位不匹配</div>
      <div class="text-[1.3rem] md:text-[1.3rem] lg:text-[1.5rem] mt-1">▸创业者：资源获取渠道匮乏</div>
      <div class="text-[1.3rem] md:text-[1.3rem] lg:text-[1.5rem] mt-1">▸新市民：在地化服务缺失</div>
      <div class="text-[1.3rem] md:text-[1.3rem] lg:text-[1.5rem] mt-1">▸银发族：再就业路</div>
    </div>
    <div class="mt-5 text-white">
      <div class="text-3xl md:text-3xl lg:text-[1.8rem]">社区就业服务站</div>
      <div class="text-[1.3rem] md:text-[1.3rem] lg:text-[1.5rem] mt-2">1.三级服务体系：线上平台（小程序）←→社区驿站（实体站点）←→就业管家（专人服务）</div>
      <div class="text-[1.3rem] md:text-[1.3rem] lg:text-[1.5rem] mt-1">2.特色服务包：</div>
      <div class="text-[1.3rem] md:text-[1.3rem] lg:text-[1.5rem] mt-1">▸15分钟岗位地图</div>
      <div class="text-[1.3rem] md:text-[1.3rem] lg:text-[1.5rem] mt-1">▸创业”工具包”共享</div>
      <div class="text-[1.3rem] md:text-[1.3rem] lg:text-[1.5rem] mt-1">▸银发技能转化计划</div>
    </div>
  </context>
  <context-colors color="bg-[#21FF21]" class="flex justify-center text-center">
    <el-image :src="ywjz6" class="w-2/3"/>
  </context-colors>

  <context-colors color="bg-[#fff]">
    <div class="text-center">
      <el-image :src="jyIPgc" class="lg:w-1/5 md:w-1/3"/>
    </div>
    <div class="mt-5 text-[#414244] ">
      <div class="text-3xl md:text-3xl lg:text-[1.8rem]">服务场景</div>
      <div class="text-[1.3rem] md:text-[1.3rem] lg:text-[1.5rem] mt-2">▸县域就业品牌打造（如“前锋直聘”“就在九龙”）</div>
      <div class="text-[1.3rem] md:text-[1.3rem] lg:text-[1.5rem] mt-1">▸城市零工文化IP（如“天工巧匠”“勤工俭学”）</div>
      <div class="text-[1.3rem] md:text-[1.3rem] lg:text-[1.5rem] mt-1">▸产业带人才IP（如“酒业人才”“美术生”）解决方案文化基</div>
    </div>
    <div class="mt-5 text-[#414244] ">
      <div class="text-3xl md:text-3xl lg:text-[1.8rem]">解决方案</div>
      <div class="text-[1.3rem] md:text-[1.3rem] lg:text-[1.5rem] mt-2">文化基因解码→视觉符号设计→服务场景植入→产业价值转化</div>
    </div>
  </context-colors>
  <context>
    <div class="text-center">
      <el-image :src="szjyxt" class="lg:w-1/5 md:w-1/3"/>
    </div>
    <div class="mt-5 text-white">
      <div class="text-3xl md:text-3xl lg:text-[1.8rem]">服务分层</div>
      <div class="text-[1.3rem] md:text-[1.3rem] lg:text-[1.5rem] mt-2">基础版（标准SaaS）</div>
      <div class="text-[1.3rem] md:text-[1.3rem] lg:text-[1.5rem] mt-1">├─岗位智能匹配引擎</div>
      <div class="text-[1.3rem] md:text-[1.3rem] lg:text-[1.5rem] mt-1">├─就业数据可视化看板</div>
      <div class="text-[1.3rem] md:text-[1.3rem] lg:text-[1.5rem] mt-1">└─政策精准推送系统</div>
      <div class="text-[1.3rem] md:text-[1.3rem] lg:text-[1.5rem] mt-1">定制版（本地化部署）</div>
      <div class="text-[1.3rem] md:text-[1.3rem] lg:text-[1.5rem] mt-1">├─多部门数据融通中台</div>
      <div class="text-[1.3rem] md:text-[1.3rem] lg:text-[1.5rem] mt-1">├─就业风险预警模型</div>
      <div class="text-[1.3rem] md:text-[1.3rem] lg:text-[1.5rem] mt-1">└─服务效能考核系统</div>
    </div>

  </context>

  <context-colors color="bg-[#fff]">
    <div class="text-center">
      <el-image :src="jykjql" class="lg:w-1/5 md:w-1/3"/>
    </div>
    <div class="mt-5 text-[#414244] text-[1.75rem]">
      <div class="text-3xl md:text-3xl lg:text-[1.8rem]">标准化产品矩阵</div>
      <el-table :data="tableData" class="w-2/3">
        <el-table-column prop="date" label="空间类型" />
        <el-table-column prop="name" label="核心功能模块"  />
        <el-table-column prop="address" label="" />
      </el-table>
      <div class="mt-5 text-[#414244] text-[1.75rem]">
        <div class="text-3xl md:text-3xl lg:text-[1.8rem]">服务特色</div>
        <div class="text-[1.3rem] md:text-[1.3rem] lg:text-[1.5rem] mt-2">▸空间即服务平台：物理空间搭载智能终端设备</div>
        <div class="text-[1.3rem] md:text-[1.3rem] lg:text-[1.5rem] mt-1">▸活动运营赋能：每月至少8场主题就业活动</div>
        <div class="text-[1.3rem] md:text-[1.3rem] lg:text-[1.5rem] mt-1">▸数据反哺设计：根据使用数据优化空间布局</div>
      </div>
    </div>
  </context-colors>
  <context>
    <div class="text-center">
      <el-image :src="jyhdst" class="lg:w-1/5 md:w-1/3"/>
    </div>
    <div class="mt-5 text-white">
      <div class="text-3xl md:text-3xl lg:text-[1.8rem]">产品化活动体系</div>
      <div class="text-[1.3rem] md:text-[1.3rem] lg:text-[1.6rem] mt-1">高频活动（标准化产品）</div>
      <div class="text-[1.3rem] md:text-[1.3rem] lg:text-[1.5rem] mt-1">├─各类招聘会（城市广场、学校、园区、社区场景）</div>
      <div class="text-[1.3rem] md:text-[1.3rem] lg:text-[1.5rem] mt-1">├─技能夜市（社区、商圈场景）</div>
      <div class="text-[1.3rem] md:text-[1.3rem] lg:text-[1.5rem] mt-1">└─创业门诊（社区、园区场景）</div>
      <div class="text-[1.3rem] md:text-[1.3rem] lg:text-[1.6rem] mt-1">定制活动（政企服务）</div>
      <div class="text-[1.3rem] md:text-[1.3rem] lg:text-[1.5rem] mt-1">├─行业技能赛事</div>
      <div class="text-[1.3rem] md:text-[1.3rem] lg:text-[1.5rem] mt-1">├─创业沙龙、政策解读会</div>
      <div class="text-[1.3rem] md:text-[1.3rem] lg:text-[1.5rem] mt-1">└─产教对接洽谈会</div>
    </div>
  </context>
  <context-colors color="bg-[#ffffff]">
    <div class="text-center">
      <el-image :src="jyjjbh" class="lg:w-1/5 md:w-1/3"/>
    </div>
    <div class="mt-5 text-[#414244]">
      <div class="text-3xl md:text-3xl lg:text-[1.8rem]">创在家门口实施模型</div>
      <div class="text-[1.3rem] md:text-[1.3rem] lg:text-[1.6rem] mt-1">基础建设</div>
      <div class="text-[1.3rem] md:text-[1.3rem] lg:text-[1.5rem] mt-1">├─社区就业服务站（实体）</div>
      <div class="text-[1.3rem] md:text-[1.3rem] lg:text-[1.5rem] mt-1">├─数字就业小程序（线上）</div>
      <div class="text-[1.3rem] md:text-[1.3rem] lg:text-[1.6rem] mt-3">服务植入</div>
      <div class="text-[1.3rem] md:text-[1.3rem] lg:text-[1.5rem] mt-1">├─社区技能共享库（居民→导师）</div>
      <div class="text-[1.3rem] md:text-[1.3rem] lg:text-[1.5rem] mt-1">├─社区微项目池（物业/业委会/居民需求）</div>

      <div class="text-[1.3rem] md:text-[1.3rem] lg:text-[1.6rem] mt-3">生态闭环</div>
      <div class="text-[1.3rem] md:text-[1.3rem] lg:text-[1.5rem] mt-1">├─居民接单→服务社区→获得收益</div>
      <div class="text-[1.3rem] md:text-[1.3rem] lg:text-[1.5rem] mt-1">└─商家入驻→服务居民→共享流量</div>
    </div>
    <div class="mt-5 text-[#414244]">
      <div class="text-3xl md:text-3xl lg:text-[1.8rem]">典型案例</div>
      <div class="text-[1.3rem] md:text-[1.3rem] lg:text-[1.5rem] mt-1">▸九龙坡巴国城社区项目：</div>
      <div class="text-[1.3rem] md:text-[1.3rem] lg:text-[1.5rem] mt-1">开发社区养老护理/家政服务等12类岗位</div>
      <div class="text-[1.3rem] md:text-[1.3rem] lg:text-[1.5rem] mt-1">孵化社区便民服务车等创业项目5个</div>
      <div class="text-[1.3rem] md:text-[1.3rem] lg:text-[1.5rem] mt-1">构建社区15分钟就业服务响应圈</div>
    </div>
  </context-colors>
  <context>
    <div class="text-center">
      <el-image :src="jsfn" class="lg:w-1/5 md:w-1/4"/>
    </div>
    <div class="mt-5 text-white">
      <div class="text-3xl md:text-3xl lg:text-[1.8rem] mb-2">定制开发案例库</div>
      <el-table :data="tableData1" class="w-2/3" class-name="tableRowClassName"
                :header-cell-style="{background:'#011A81',color:'#FFF'}" :cell-style="{background:'#011A81',color:'#FFF'}">
        <el-table-column prop="date" label="系统类型" />
        <el-table-column prop="name" label="技术亮点"  />
        <el-table-column prop="address" label="" />
      </el-table>
    </div>
  </context>


</div>
</template>

<style >

</style>
